//Get Product Action Types
export const PRODUCTS_ARE_FETCHING = "PRODUCTS_ARE_FETCHING";
export const PRODUCTS_FETCHED_SUCCESS = "PRODUCTS_FETCHED_SUCCESS";
export const PRODUCTS_FETCHED_ERROR = "PRODUCTS_FETCHED_ERROR";
export const PRODUCTS_CLEAR_ERROR = "PRODUCTS_CLEAR_ERROR";

//Get user profile info
export const GET_USER_PROFILE_INFO = "GET_USER_PROFILE_INFO";
export const GET_USER_PROFILE_INFO_SUCCESS = "GET_USER_PROFILE_INFO_SUCCESS";
export const GET_USER_PROFILE_INFO_ERROR = "GET_USER_PROFILE_INFO_ERROR";

//Get user subscription details
export const SUBSCRIPTION_DETAILS_ARE_FETCHING =
  "SUBSCRIPTION_DETAILS_ARE_FETCHING";
export const SUBSCRIPTION_DETAILS_HAS_FETCHED_SUCCESS =
  "SUBSCRIPTION_DETAILS_HAS_FETCHED_SUCCESS";
export const SUBSCRIPTION_DETAILS_HAS_FETCHED_ERROR =
  "SUBSCRIPTION_DETAILS_HAS_FETCHED_ERROR";
export const SUBSCRIPTION_DETAILS_CLEAR = "SUBSCRIPTION_DETAILS_CLEAR";

//Free trial
export const GET_FREE_TRIAL_INITIATED = "GET_FREE_TRIAL_INITIATED";
export const GET_FREE_TRIAL_SUCCESS = "GET_FREE_TRIAL_SUCCESS";
export const GET_FREE_TRIAL_ERROR = "GET_FREE_TRIAL_ERROR";
export const FREE_TRIAL_CLEAR = "FREE_TRIAL_CLEAR";

//Terms of Use Dialog
export const GET_TERMS_DLG = "GET_TERMS_DLG";
export const GET_TERMS_DLG_SUCCESS = "GET_TERMS_DLG_SUCCESS";
export const GET_TERMS_DLG_ERROR = "GET_TERMS_DLG_ERROR";
export const GET_TERMS_DLG_ERROR_MSG =
  "Unable to fetch the terms of use, please try again.";
